import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('price_checker'),
    subtitle: defineMessage('approvalmax_makes_it_ea_e_price_checker_feature'),
    optionTrue: defineMessage('yes_enable_this_feature'),
    optionFalse: defineMessage('no_i_dont_want_to_use_this_feature'),
};
